/* eslint-disable */
import createIcon from '../createIcon';

const IconCheckSquareFilled = createIcon({
  name: 'icon-check-square-filled',
  content: '<path d="M1024 0v1024H0V0h1024zM805.823 218L398.529 625.294l-181.02-181.02L127 534.784l181.02 181.019 90.509 90.51L896.332 308.51 805.822 218z" fill="currentColor" fill-rule="evenodd"/>',
  width: 1024,
  height: 1024
});
export default IconCheckSquareFilled;
